import script from "./success.vue?vue&type=script&lang=jsx"
export * from "./success.vue?vue&type=script&lang=jsx"

const __exports__ = script;

export default __exports__